import { useContext } from "react";
import { Link } from "react-router-dom";
import { useQuery} from "@tanstack/react-query"
import Markdown from 'react-markdown'
import axios from "axios";
import { apiRoot, UserContext } from "..";
import { Spinner } from "react-bootstrap";

const ArticleView = (articleKey) => {
  const user = useContext(UserContext);

  const fetchArticleQuery = useQuery(['fetchArticle'], async () => {
    const {data} = await axios.get(apiRoot + '/articles/' + articleKey);
    return data;
  }, {
    onError: (err) => {
      console.log('fetchArticle error: ' + err) // TODO
    }
  });

  return (
    <>
{fetchArticleQuery.isLoading &&
<div className="text-center">
  <Spinner animation="border" variant="secondary" role="status">
    <span className="visually-hidden">Nahrávám...</span>
  </Spinner>
</div>
}
{fetchArticleQuery.isError &&
  <div className="alert alert-danger" role="alert">Chyba při nahrávání článku.</div>
}
{fetchArticleQuery.data &&
  <>
    <div>
      <span>
        <i className={"fa " + fetchArticleQuery.data.icon + " fa-3x fa-in-header align-middle"} aria-hidden="true"></i>
        <h2 className="d-inline-block align-middle">{fetchArticleQuery.data.header}</h2>
      </span>
    </div>
    <div className="text-break">
      <Markdown>{fetchArticleQuery.data.content}</Markdown>
    </div>
    <div style={{fontStyle: "italic", textAlign: "right"}}>Naposledy upravil: {fetchArticleQuery.data.author}, {fetchArticleQuery.data.updated}</div>
    {user && user.isPowerUser &&
    <div style={{textAlign: "right"}}>
      <span> <Link to={"/upravit-clanek"} state={{articleKey: articleKey}} className="btn btn-success align-middle" role="button"><i className="fa fa-pencil" aria-hidden="true"></i> Upravit článek</Link></span>
    </div>
    }
  </>
}
    </>
  );
};
  
export default ArticleView;